import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.scss";

import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

import Main from "./containers/Main";
import AboutMe from "./other-containers/AboutMe";
import Project from "./other-containers/Project";

function App() {

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,        // scroll duration (higher = slower/smoother)
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // ease out expo
      smooth: true,
      mouseMultiplier: 1,   // mouse wheel sensitivity
      smoothTouch: false,   // disable on touch (mobile)
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy(); // cleanup on unmount
    };
  }, []);
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/project/:projectName" element={<Project />} />
      </Routes>
    </Router>
  );
}

export default App;
